export default __webpack_public_path__ + "static/media/image-placeholder.867a592d.svg";